import type {
	MetricType,
	SuggestAnalyticsMonitorOut,
	SuggestDirectMonitorOut,
} from '@repo/api-codegen';
import type { IconNames } from '@repo/foundations';

export type MonitorType = {
	metric_type: MetricType;
	integration_type?: string;
} & (
	| Omit<SuggestAnalyticsMonitorOut, 'metric_type'>
	| Omit<SuggestDirectMonitorOut, 'metric_type'>
);

export const isAnalyticsMonitor = (
	type: MonitorType
): type is { metric_type: MetricType } & Omit<
	SuggestAnalyticsMonitorOut,
	'metric_type'
> => type.metric_type === 'analytics';

export function equalMonitorTypes(a: MonitorType, b: MonitorType) {
	if (a.metric_type !== b.metric_type) return false;
	if (isAnalyticsMonitor(a) !== isAnalyticsMonitor(b)) return false;
	if (isAnalyticsMonitor(a) && isAnalyticsMonitor(b))
		return a.integration_metric === b.integration_metric;
	return true;
}

export type MonitorSpec = {
	iconName: IconNames;
	title: string;
	description: string;
	group:
		| 'Table'
		| 'Column'
		| 'Custom'
		| 'Warehouse'
		| 'Tests'
		| 'Pipeline'
		| 'Analytics';
	integrationType?: string; // Only exist on analytics monitor
	type: MonitorType;
};
